import React from "react"
import { graphql } from "gatsby"
import styles from "../styles/global.module.scss"

// Components
import Layout from "../components/layout/layout"
import QuotingForm from "../components/quoting/quoting-form"

import { useGetTokens } from "../hooks/useGetTokens"
import convertTokens from "../helpers/convertTokens"
import setSeoData from "../helpers/setSeoData"

export default ({ data, location }) => {
  // Get contact content from markdown
  const { quoting, settings } = data
  let quote_settings
  if (settings.edges.length > 0) {
    quote_settings = settings.edges[0].node
  }
  // Get metadata
  const metadata = useGetTokens()

  // If linked from service page, get selected service
  let selectedService = ""
  location.state && location.state.service
    ? (selectedService = location.state.service)
    : (selectedService = "")

  let seo_data = setSeoData(quoting.frontmatter)

  return (
    <Layout location={location} seo_data={seo_data}>
      <div id={styles.quotingPage} className={styles.container}>
        <h1>{quoting.frontmatter.title}</h1>
        <div
          dangerouslySetInnerHTML={{
            __html: convertTokens(quoting.html, metadata),
          }}
        />
        <QuotingForm
          selectedService={selectedService}
          quote_settings={quote_settings}
        />
      </div>
    </Layout>
  )
}
export const query = graphql`
  {
    quoting: markdownRemark(frontmatter: { title: { eq: "Request A Quote" } }) {
      id
      html
      frontmatter {
        title
        meta {
          title
          description
          page_visible
        }
      }
    }
    settings: allModulesYaml(
      filter: { quoting_id: { eq: "quoting_form_001" } }
    ) {
      edges {
        node {
          id
          Availability
          Country
          State
        }
      }
    }
  }
`
